import React, { useState, useEffect } from "react"
import {
  Typography,
  Button,
  Dialog,
  Grid,
  Divider,
  IconButton,
  makeStyles,
  CircularProgress,
} from "@material-ui/core"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import CloseIcon from "@material-ui/icons/Close"
import commonStyles from "../../styles/Pages/common/styles"
import { withTheme } from "styled-components/macro"
import { useTranslation } from "react-i18next"

const defaultHandleCloseAndRedirect = ({
  setOpen,
  setOpenConfirmationDialog,
  setReDirect = () => {},
  handleCloseButtonTrigger,
}) => {
  setOpen(false)
  setOpenConfirmationDialog(false)
  setReDirect(true)
  handleCloseButtonTrigger = () => {}
}

const useStyles = makeStyles({
  ConfirmationDialog: {
    width: 500,
    maxWidth: "95%",
    borderRadius: 10,

    "@media (max-width:767px)": {
      width: "95%",
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px 18px",
    minHeight: 52,
  },
  closeButton: {
    position: "absolute",
    right: 10,

    padding: 4,
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
  },

  title: {
    fontSize: 18,
    fontWeight: 600,
    marginLeft: 6,
    color: "#4b4b4b",
  },

  body: {
    padding: "20px 20px",
    textAlign: "center",
  },

  bodyText: {
    fontSize: 18,
    fontWeight: 700,
    color: "#333",
    lineHeight: "28px",
  },

  footer: {
    display: "flex",
    justifyContent: "center",
    gap: 8,
    padding: "10px 16px",
  },

  cancelButton: {
    minWidth: 82,
    height: 32,
    textTransform: "none",
    borderRadius: 4,
  },

  confirmButton: {
    minWidth: 82,
    height: 32,
    textTransform: "none",
    borderRadius: 4,
    background: "#e53935",

    "&:hover": {
      background: "#d32f2f",
    },
  },
})

function NewConfirmationDialog(props) {
  const {
    handleCloseAndRedirect = defaultHandleCloseAndRedirect,
    setOpenConfirmationDialog = () => {},
    openConfirmationDialog,
    handleCloseButtonTrigger = () => {},
    handleCustomCloseRedirect = () => {},
    popupTitle = "Confirm",
    confirmLoading = false,
    confirmDisabled = false,
  } = props || {}

  const [open, setOpen] = useState(false)

  const classes = useStyles()
  const commonClasses = commonStyles()
  const { t } = useTranslation()

  const handleClose = () => {
    if (confirmLoading) return
    setOpen(false)
    setOpenConfirmationDialog(false)
    handleCloseButtonTrigger()
  }

  useEffect(() => {
    setOpen(openConfirmationDialog)
  }, [openConfirmationDialog])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          borderRadius: 10,
          overflow: "hidden",
        },
      }}
    >
      <Grid container direction="column" className={classes.ConfirmationDialog}>
        {/* Header */}
        <Grid className={classes.header}>
          <div className={classes.titleWrapper}>
            <CheckCircleIcon
              style={{
                color: "#28a745",
                fontSize: 18,
              }}
            />

            <Typography variant="h6" className={classes.title}>
              {props.textHeadingContent
                ? props.textHeadingContent
                : t(popupTitle)}
            </Typography>
          </div>

          <IconButton
            size="small"
            onClick={handleClose}
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        <Divider />

        {/* Body */}
        <Grid className={classes.body}>
          {props.textContent ? (
            <Typography className={classes.bodyText}>
              {props.textContent}
            </Typography>
          ) : (
            <>
              <Typography variant="body1">
                {props.isdelete
                  ? "Selected item(s) would be archived, do you really want to continue?"
                  : null}
              </Typography>

              <Typography variant="body1">
                {props.setCancel ? t("ConfirmDialogText1") : null}
              </Typography>
            </>
          )}

          {props.deleteContent ? (
            <Typography variant="body1" style={{ marginTop: 8 }}>
              {props.deleteContent}
            </Typography>
          ) : null}

          {props.setLogout ? (
            <Typography variant="body1" style={{ marginTop: 8 }}>
              {props.setLogout}
            </Typography>
          ) : null}
        </Grid>

        {/* Footer */}
        <Grid className={classes.footer}>
          <Button
            variant="outlined"
            color="default"
            size="small"
            disabled={confirmLoading}
            className={`${commonClasses.defaultOutlinedButton} ${classes.cancelButton}`}
            onClick={handleClose}
          >
            {props.cancelButtonText || window?.globalTranslation("NO")}
          </Button>

          <Button
            variant="contained"
            size="small"
            disabled={confirmLoading || confirmDisabled}
            className={`${commonClasses.containedButton} ${classes.confirmButton}`}
            onClick={() =>
              handleCustomCloseRedirect() ||
              handleCloseAndRedirect({
                ...props,
                setOpen,
              })
            }
            startIcon={
              confirmLoading ? (
                <CircularProgress size={16} style={{ color: "#fff" }} />
              ) : null
            }
          >
            {props.confirmButtonText || window?.globalTranslation("YES")}
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export { NewConfirmationDialog }

export default withTheme(NewConfirmationDialog)
